import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction-composing.title',
    defaultMessage: 'EDIT SIMULATION',
  },
  back: {
    id: 'simulated.correction-composing.back',
    defaultMessage: 'Back',
  },
  correctionMethod: {
    id: 'simulated.correction-composing.correctionMethod',
    defaultMessage: 'Sending scanned essays',
  },
  choiceInfo: {
    id: 'simulated.correction-composing.choiceInfo',
    defaultMessage: 'Click the button below to upload the scanned essay sheets',
  },
  sendCardsSubtitle: {
    id: 'simulated.correction-composing.sendCardsSubtitle',
    defaultMessage: 'Sending scanned essay sheets',
  },
  sendCardsInfo: {
    id: 'simulated.correction-composing.sendCardsInfo',
    defaultMessage:
      'In this method, the essay sheets must be scanned by the school itself and then loaded into the system via the button below.',
  },
  loadCardsButton: {
    id: 'simulated.correction-composing.loadCardsButton',
    defaultMessage: 'Upload files from digitized essays',
  },
  class: {
    id: 'simulated.correction-composing.class',
    defaultMessage: 'Class',
  },
  school: {
    id: 'simulated.correction-composing.school',
    defaultMessage: 'School',
  },
  forbidden: {
    id: 'simulated.correction-composing.forbidden',
    defaultMessage: 'Forbidden',
  },
  needClickBefore: {
    id: 'simulated.correction-composing.needClickBefore',
    defaultMessage: 'You need to select a class before',
  },
  problemsFound: {
    id: 'simulated.correction-composing.problemsFound',
    defaultMessage: 'Problems found',
  },
  upload: {
    id: 'simulated.correction-composing.upload',
    defaultMessage: 'Upload',
  },
  close: {
    id: 'simulated.correction-composing.close',
    defaultMessage: 'Close',
  },
  save: {
    id: 'simulated.correction-composing.editModal.save',
    defaultMessage: 'Save editions',
  },
  essayUploaded: {
    id: 'simulated.correction-composing.essayUploaded',
    defaultMessage: 'Essay uploaded',
  },
});
